import { useEffect, useRef } from "react";
import { Toast } from "../../components/Toast";

/**
 * Shows `message` as an error toast and calls `onNotFound` once for each `notFoundKey`, so a
 * routed drawer whose URL id does not resolve closes itself. Pass `null` while the id is
 * still resolving or once it has resolved. The ref keeps StrictMode's double effect from
 * reporting twice; it resets when the key returns to `null`.
 */
export function useRouteNotFoundToast(
  notFoundKey: string | null,
  message: string,
  onNotFound: () => void,
): void {
  const reportedKeyRef = useRef<string | null>(null);
  useEffect(() => {
    if (notFoundKey == null) {
      // Forget the key once the route is left, so revisiting the same bad URL reports again.
      reportedKeyRef.current = null;
      return;
    }
    if (reportedKeyRef.current === notFoundKey) {
      return;
    }
    reportedKeyRef.current = notFoundKey;
    Toast(message, "error");
    onNotFound();
  }, [notFoundKey, message, onNotFound]);
}
